import auth from '@/middleware/auth';

const middlewares = {
    core: { //will be included in any case.
        auth: auth
    },
    common: {  //will be included optionally.
    }
}

class Middleware {
    static activeMiddlewares = {};
    static runNextMiddlewareStatus = true;

    static get(key) {
        return this.activeMiddlewares[key] ?? null;
    }

    static getActiveMiddlewares(){
        return Object.values(this.activeMiddlewares);
    }

    static setMiddlewares(groupKey, childrens = []) {
        for (let middlewareKey in middlewares[groupKey]) {
            if((!childrens.length) || (childrens.length && childrens.includes(middlewareKey))){
                this.activeMiddlewares[middlewareKey] = middlewares[groupKey][middlewareKey];
            }
        }
    }


    static loadMiddlewares(options) {
        this.setMiddlewares('core');

        if(options.middleware) {
            this.setMiddlewares('common', options.middleware)
        }

        if(options.without_middleware) {
            options.without_middleware.forEach((key) => {
                delete this.activeMiddlewares[key];
            });
        }

        return Object.values(this.activeMiddlewares);
    }

    static redirectRouteMode(key, store, router, route){
        let middleware = this.get(key);

        if(middleware) {
            const context = {to: route, store: store, next: router.push, redirectRouteMode: true};
            middleware({...context});
        }
    }

    static runMiddleware(context, index = 0) {
        context.nextMiddleWare = undefined;

        let middlewares = this.getActiveMiddlewares();
        let currentMiddleware = middlewares[index];
        let nextMiddleware = middlewares[index + 1];

        if(nextMiddleware){
            context.nextMiddleWare = () => {
                return this.runMiddleware(context, (index + 1));
            };
        }

        return currentMiddleware(context)
    }
}

export default Middleware;